//any type checked blueice
import { KeyValueDTO } from '@ms/core';
import { SubjectCategoryEnum } from 'app/main/timetable/subjects/subject-category.enum';
import { SubjectCategory } from '../../subject-categories/subject-category.model';
import { ColorPalette } from '../model/color-palette.model';
import { CourseGradeSettings } from '../model/course.model';
import { TranslatableString } from '../model/translateble-string.model';
export interface ISubject {
    id: string;
    name?: string;
    code?: string;
    subjectCategory?: SubjectCategory;
    category?: SubjectCategoryEnum;
    active?: boolean;
    deleted?: boolean;
    translateName?: TranslatableString[];
    css?: ColorPalette;
    projectId?: string;
    speechLanguage?: SpeechLanguage;
    rooms?: KeyValueDTO[];
    showToAllSchools?: boolean;
    schoolIds?: string[];
    stateCode?: string;
    gradeSettings?: CourseGradeSettings;
    creditTypes?: string[];
    termCode?: string;
    uuid?: string;
    revisionId?: string;
    changedDate?: Date;
    changedBy?: string;
    createdDate?: Date;
    createdBy?: string;
}

export class Subject implements ISubject {
    constructor(
        public id: string,
        public name?: string,
        public code?: string,
        public subjectCategory?: SubjectCategory,
        public category?: SubjectCategoryEnum,
        public active?: boolean,
        public deleted?: boolean,
        public translateName?: TranslatableString[],
        public css?: ColorPalette,
        public projectId?: string,
        public speechLanguage?: SpeechLanguage,
        public rooms?: KeyValueDTO[],
        public schoolIds?: string[],
        public showToAllSchools?: boolean,
        public enableForSelectedSchools?: boolean,
        public stateCode?: string,
        public gradeSettings?: CourseGradeSettings,
        public termCode?: string,
        public uuid?: string,
        public revisionId?: string,
        public changedDate?: Date,
        public changedBy?: string,
        public createdDate?: Date,
        public createdBy?: string
    ) {
        this.id = id ? id : null;
        this.name = name ? name : '';
        this.name = name ? name : '';
        this.code = code ? code : '';
        this.subjectCategory = subjectCategory ? subjectCategory : new SubjectCategory();
        this.category = category ? category : SubjectCategoryEnum.TECHNICAL;
        this.active = active ? active : true;
        this.deleted = deleted ? deleted : false;
        this.translateName = translateName ? translateName : [];
        this.css = css ? css : { name: 'Default', value: '#fff', foreground: '#000' };
        this.projectId = projectId ? projectId : null;
        this.speechLanguage = speechLanguage ? speechLanguage : null;
        this.rooms = rooms ? rooms : [];
        this.schoolIds = schoolIds ? schoolIds : [];
        this.showToAllSchools = showToAllSchools ? showToAllSchools : false;
        this.enableForSelectedSchools = enableForSelectedSchools ?? false;
        this.stateCode = stateCode ?? null;
        this.gradeSettings = gradeSettings ?? new CourseGradeSettings();
        this.termCode = termCode ?? null;
        this.uuid = uuid ? uuid : null;
        this.revisionId = revisionId ? revisionId : null;
        this.changedDate = changedDate ? changedDate : null;
        this.changedBy = changedBy ? changedBy : null;
        this.createdDate = createdDate ? createdDate : null;
        this.createdBy = createdBy ? createdBy : null;
    }
}

export const SpeechLanguage = {
    en_GB: 'en-GB',
    en_US: 'en-US',
    ru_RU: 'ru-RU',
    tr_TR: 'tr-TR',
    fr_FR: 'fr-FR',
    de_DE: 'de-DE',
} as const;
export type SpeechLanguage = (typeof SpeechLanguage)[keyof typeof SpeechLanguage];

export class SubjectImport {
    constructor(
        public id?: string,
        public name?: string,
        public code?: string,
        public category?: SubjectCategoryEnum,
        public nameErrorMessage?: string,
        public codeErrorMessage?: string
    ) {
        this.id = id ?? null;
        this.name = name ?? null;
        this.code = code ?? null;
        this.category = category ?? null;
        this.nameErrorMessage = nameErrorMessage ?? null;
        this.codeErrorMessage = codeErrorMessage ?? null;
    }
}

export class WorkingCoursePlanSearchDTO {
    public gradeLevelIds?: string[];
    public subjectIds?: string[];
}
